import React from 'react';
import Button from 'material-ui/Button';
import Dialog from 'material-ui/Dialog/Dialog';
import DialogContent from 'material-ui/Dialog/DialogContent'
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import IconButton from 'material-ui/IconButton';
import Typography from 'material-ui/Typography';
import Slide from 'material-ui/transitions/Slide';
import AppTheme from './AppTheme';
import {connect} from "react-redux";
import {expectResult} from '../actions/process';
import {setPath} from "../actions/filters";
import SessionList from './SessionList';
import EventDetailsDialog from './EventDetailsDialog';

const DetailsDialog=(props)=> {
        const {result,userSessions,expectedResult, previousResult,dispatch,version,userInfo, errorCount } = props;
        console.log(userSessions);
        return (
            <div>
            <AppTheme>
                <Dialog
                    fullScreen
                    open={result===expectedResult}
                    TransitionComponent={Slide} >
                    <AppBar position="static" color="secondary">
                        <Toolbar>

                            <Typography variant="title" color="primary" className='details-dialog-flex'>
                                 Всего входов в игру:   {userSessions && userSessions.length} {version ? '. Версия игры: '+version :''} . Количество ошибок: {errorCount}
                            </Typography>
                            <span/>
                            <IconButton color="secondary" onClick={()=>{
                                dispatch(setPath('/date/users'));
                                dispatch(expectResult(previousResult));
                            }} aria-label="Close">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                    <path  fill="#7a7a7a" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
                            </IconButton>
                        </Toolbar>
                        <Toolbar>
                            <Typography color="primary" className='details-dialog-flex'>
                                {userSessions && userSessions.length && userSessions[0] ?
                                  "Железо: "+  userSessions[0]._id + ", " :""}
                                {userInfo ? " usernames: "+ userInfo.usernames + ", устройство: "+userInfo.name + ", модель: " +userInfo.model +", ОС: " +userInfo.os : ""}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <div>
                        <SessionList/>
                    </div>
                </Dialog>
            </AppTheme>
                <EventDetailsDialog/>
            </div>
        );
    };

const mapStateToProps=(state)=>({result:state.process.result,userSessions:state.data.userSessions, version : state.data.version, userInfo : state.data.userInfo, errorCount: state.data.errorCount});
const ConnectedDetailsDialog=connect(mapStateToProps)(DetailsDialog);
export default ConnectedDetailsDialog;
